export const persist = (key, value) => window.localStorage.setItem(key, value);
export const getPersisted = key => window.localStorage.getItem(key);
export const removePersisted = key => window.localStorage.removeItem(key);
